
import React, { useContext, useState, Fragment, useEffect } from 'react';
import AppContext from "../../AppContext";
import { site } from '../../configs/site';
import { useCases } from '../../configs/useCases';
import  { Auth } from 'aws-amplify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Dialog, Transition } from '@headlessui/react'
import { Bars3Icon, XMarkIcon, ArrowLeftOnRectangleIcon, UsersIcon, CpuChipIcon, EnvelopeIcon, ArrowRightIcon, HomeIcon } from '@heroicons/react/24/outline'
import { preloadHubSpotFormsScript } from '../../services/HubSpotForms';


// const classNames = (...classes) => {
//   return classes.filter(Boolean).join(' ')
// }


const MainMenu = (props) => {

  const { transparentLogo, apiKey, menuTitle, setMenuTitle, user } = useContext(AppContext);

  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();


  const [mainMenuOpen, setMainMenuOpen] = useState(false)

  useEffect(() => {
    if(Object?.keys(params)?.length === 0){
      setMenuTitle(location.pathname === '/user-management' ? 'User Management' : null)
    }
    //eslint-disable-next-line
  }, [params])

  const navigateAction = (route) => {
    setMainMenuOpen(false)
    navigate(route);
  }

  const toggleLeftSide = () => {
    setMainMenuOpen(!mainMenuOpen)
  }

  // useEffect(() => {
  //   enabled &&
  //   setRealTime(realTime => !realTime)
  // }, [enabled])

  return <>
    {/* ************************************************************ */}
    {/* *******************MOBILE MENU****************************** */}
    {/* ************************************************************ */}
    <Transition.Root show={mainMenuOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => toggleLeftSide()}>
        <Transition.Child as={Fragment}
          enter="transition-opacity ease-linear duration-300" enterFrom="opacity-0" enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300" leaveFrom="opacity-100" leaveTo="opacity-0"
        >
        <div className="fixed inset-0 bg-gray-900/80" />
        </Transition.Child>
          <div className="fixed inset-0 flex justify-end">
            <Transition.Child as={Fragment}
              enter="transition ease-in-out duration-300 transform" enterFrom="translate-x-full" enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform" leaveFrom="translate-x-0" leaveTo="translate-x-full"
            >
              <Dialog.Panel className="relative ml-16 flex w-full max-w-xs flex-1">
                <Transition.Child as={Fragment}
                  enter="ease-in-out duration-300" enterFrom="opacity-0" enterTo="opacity-100"
                  leave="ease-in-out duration-300" leaveFrom="opacity-100" leaveTo="opacity-0"
                >
                  <div className="absolute right-full top-0 flex w-16 justify-center pt-5">
                    <button type="button" className="-m-2.5 p-2.5" onClick={() => toggleLeftSide()}>
                      <span className="sr-only">Close sidebar</span>
                      <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                    </button>
                  </div>
                </Transition.Child>

                {/* MOBILE MOBILE MOBILE, swap this element with another sidebar if you like */}
                <div className="flex grow flex-col gap-y-5 bg-othergray-50 px-6 pb-4">
                  <nav className="flex flex-1 flex-col overflow-y-auto hide-scrollbar mt-4">
                    <ul className="flex flex-1 flex-col gap-y-7">

                    {/* Home -- the logo in the header already links back to
                        "/", but this sidebar had no direct way there, so
                        clicking the hamburger and picking a use case (or
                        anything else) was the only path in/out of it. */}
                    <li>
                      <button
                        type="button"
                        onClick={() => navigateAction('/')}
                        className="rounded-md text-othergray-700 text-lg group flex w-full py-2 px-2 gap-x-3 font-bold leading-6 hover:bg-plumbus-100 hover:text-primary-800"
                      >
                        <HomeIcon
                          className="h-6 w-6 text-othergray-700 group-hover:text-primary-800"
                          aria-hidden="true"
                        />
                        Home
                      </button>
                    </li>

                    {/* <li className="-mx-6 mt-auto">
            <a
              href="#"
              className="flex items-center gap-x-4 px-6 py-3 text-sm font-semibold leading-6 text-white hover:bg-indigo-700"
            >
              <img
                className="h-8 w-8 rounded-full bg-indigo-700"
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                alt=""

              />
              <span className="sr-only">Your profile</span>
              <span aria-hidden="true">Tom Cook</span>
            </a>
          </li> */}
                        <li>
                          <h1 className="font-display font-bold text-2xl text-primary-800 mb-4">
                            Use Cases
                          </h1>

                          {useCases.filter((useCase) => !useCase.unlisted).map((useCase) => (
                            <button
                              key={useCase.id}
                              // Same fix as Home.jsx: always route through
                              // /:useCaseId (App.jsx dropped the "/use-case/"
                              // prefix -- see its routing comment), the only
                              // pattern actually registered and handled by
                              // UseCaseView (looked up by `id`). Each use
                              // case's own `route` field doesn't match any
                              // configured route, so it was silently falling
                              // through to Content.jsx's catch-all "*" route,
                              // which redirects to the first dashboard.
                              onClick={() =>
                                navigateAction(
                                  `/${encodeURIComponent(useCase.id)}`
                                )
                              }
                              className="flex text-left w-full rounded-md text-md font-semibold leading-6 py-2 px-2 text-othergray-700 hover:bg-plumbus-100 hover:text-primary-800"
                            >
                              {useCase.title}
                            </button>
                          ))}
                        </li>

                        {site.contact.enabled && (
                          <li className="xms:hidden">
                            <button
                              type="button"
                              onClick={() => navigateAction('/contact')}
                              onMouseEnter={preloadHubSpotFormsScript}
                              onTouchStart={preloadHubSpotFormsScript}
                              className="rounded-md text-othergray-700 text-lg group flex w-full py-2 px-2 gap-x-3 font-bold leading-6 hover:bg-plumbus-100 hover:text-primary-800"
                            >
                              <EnvelopeIcon
                                className="h-6 w-6 text-othergray-700 group-hover:text-primary-800"
                                aria-hidden="true"
                              />
                              {site.contact.buttonLabel}
                            </button>
                          </li>
                        )}

                          <li >
                          {import.meta.env.VITE_SSO === "true" &&  <>
                            {/* <div
                              className="flex flex-row rounded-md p-2 text-sm font-semibold text-gray-700"
                            >
                              <button
                                onClick={() => navigateAction(`q`)}
                                className="flex text-left w-full gap-x-3 rounded-md px-2 text-sm font-semibold leading-6 text-othergray-700 hover:bg-plumbus-100 hover:text-primary-800"
                              >
                                <CpuChipIcon
                                className="h-6 w-6  text-othergray-700 group-hover:text-primary-800"
                                aria-hidden="true"
                              />
                                Open Amazon Q
                              </button>
                            </div> */}

                            <a
                              href={'/q'}

                              className=" rounded-md text-othergray-700 text-lg group flex w-full py-2 px-2 gap-x-3 font-bold leading-6 hover:bg-plumbus-100 hover:text-primary-800"
                            >
                              <CpuChipIcon
                                className="h-6 w-6  text-othergray-700 group-hover:text-primary-800"
                                aria-hidden="true"
                              />
                            Open Amazon Q
                            </a>

                            </>
                        }

                          {!apiKey && user?.attributes?.nickname === "ADMIN" &&
                            <button
                              onClick={() => navigateAction('/user-management')}
                              className=" rounded-md text-othergray-700 text-lg group flex w-full py-2 px-2 gap-x-3 font-bold leading-6 hover:bg-plumbus-100 hover:text-primary-800"
                            >
                              <UsersIcon
                                className="h-6 w-6  text-othergray-700 group-hover:text-primary-800"
                                aria-hidden="true"
                              />
                            User Management
                            </button>
                        }
                            {!apiKey && <button
                              onClick={() => Auth.signOut()}
                              className=" rounded-md text-othergray-700 text-lg group flex w-full py-2 px-2 gap-x-3 font-bold leading-6 hover:bg-plumbus-100 hover:text-primary-800"
                            >
                              <ArrowLeftOnRectangleIcon
                                className="h-6 w-6  text-othergray-700 group-hover:text-primary-800"
                                aria-hidden="true"
                              />
                              Logout
                            </button>}
                          </li>
                    </ul>
                </nav>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>


    {/* ************************************************************ */}
    {/* *******************Header*********************************** */}
    {/* ************************************************************ */}
    <div className="sticky top-0 z-40 flex flex-col shrink-0">
      <div className="flex h-16 sm:h-20 justify-between items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 pl-4 pr-4 sm:pr-6" >

        {/* Logo + "in collaboration with AWS" lockup */}
        <div className="flex h-full items-center gap-3 sm:gap-4 min-w-0 shrink">
          {/* West Loop logo is now a link back to the site's home route (/),
              same as clicking any other site's logo does -- previously just
              a static image with nowhere to click. */}
          <button
            type="button"
            onClick={() => navigate('/')}
            className="flex shrink-0 items-center rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
          >
            <img
              src="/logos/WLS-logo.svg"
              alt={site.title}
              className="h-7 w-auto shrink-0 sm:h-14"
            />
          </button>

          <div className="h-6 w-px shrink-0 bg-gray-200 sm:h-8" aria-hidden="true" />

          <div className="flex items-center">
            <img
              src="/logos/aws.png"
              alt="Powered by AWS Cloud Computing"
              className="h-5 w-auto sm:h-8"
            />
          </div>
        </div>

        {/* Center nav */}
        <nav className="hidden flex-1 items-center justify-center gap-8 lg:flex">
          {import.meta.env.VITE_SSO === "true" && (
            <a
              href="/q"
              className="text-sm font-semibold leading-6 text-gray-700 hover:text-primary-700"
            >
              Amazon Q
            </a>
          )}

          {!apiKey && user?.attributes?.nickname === "ADMIN" && (
            <button
              type="button"
              onClick={() => navigateAction('/user-management')}
              className="text-sm font-semibold leading-6 text-gray-700 hover:text-primary-700"
            >
              User Management
            </button>
          )}
        </nav>

        {/* Right side: menu title (in-app breadcrumb), CTA, hamburger */}
        <div className="flex h-full items-center gap-2 sm:gap-4">
          {menuTitle && (
            <div className="hidden self-center text-sm font-semibold leading-6 text-gray-500 max-h-full overflow-hidden whitespace-nowrap text-ellipsis sm:block">
              {menuTitle}
            </div>
          )}

          {site.contact.enabled && (
            <button
              type="button"
              onClick={() => navigateAction('/contact')}
              // Warms up HubSpot's form-embed script (see
              // services/HubSpotForms.js) as soon as a visitor's finger
              // touches this button, before the tap even registers as a
              // click/navigation -- this is the always-visible contact
              // button on every page, so it's the most reliable place to
              // get a head start on that fetch chain, especially on a slow
              // mobile connection where /contact's own effect starting the
              // same fetch only after the page has already mounted was
              // what made the form feel slow to appear.
              onMouseEnter={preloadHubSpotFormsScript}
              onTouchStart={preloadHubSpotFormsScript}
              // Was hidden below 450px (xms), which is narrower than most
              // phone screens, so the button effectively never showed up on
              // mobile. Now it's always visible: a compact icon-only circle
              // on narrow screens, expanding to the full pill w/ label on
              // larger ones.
              className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-primary-600 p-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 sm:px-4 sm:py-2"
            >
              <span className="sr-only sm:not-sr-only">{site.contact.buttonLabel}</span>
              <EnvelopeIcon className="h-4 w-4 sm:hidden" aria-hidden="true" />
              <ArrowRightIcon className="hidden h-4 w-4 sm:block" aria-hidden="true" />
            </button>
          )}

          <button type="button" className="-m-2.5 p-2.5 text-gray-500 hover:text-gray-700" onClick={() => toggleLeftSide()}>
            <span className="sr-only">Open sidebar</span>
            <Bars3Icon className="h-7 w-7" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>

  </>
};

export default MainMenu;
